export default __webpack_public_path__ + "static/media/mo-dongho-12-2@2x.81ffd9f8.png";